import React from 'react';
import './AnnouncementBar.css';

const MESSAGE = 'Fabricación propia · Envíos a todo el país';
/** Repeticiones por mitad del track (suficientes para pantallas anchas) */
const COPIES = 8;

const AnnouncementBar = () => {
  const sequence = Array.from({ length: COPIES }, (_, i) => (
    <span key={i} className="announcement-item">
      {MESSAGE}
    </span>
  ));

  return (
    <div className="announcement-bar" role="region" aria-label="Información comercial">
      <p className="visually-hidden">{MESSAGE}</p>
      <div className="announcement-marquee" aria-hidden="true">
        <div className="announcement-track">
          <div className="announcement-group">{sequence}</div>
          <div className="announcement-group">{sequence}</div>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementBar;
